module.exports = __webpack_public_path__ + "static/media/national_register_pj.4920a7ad.png";